import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import SiteAuth from './components/SiteAuth';
import Header from './components/Header';
import Hero from './components/Hero';
import WhatIsBurritoSewa from './components/WhatIsBurritoSewa';
import WhySponsor from './components/WhySponsor';
import LifeEvents from './components/LifeEvents';
import PastEvents from './components/PastEvents';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import EventPlanning from './components/EventPlanning';
import './App.css';

const AppContainer = styled.div`
  min-height: 100vh;
  font-family: 'Inter', sans-serif;
`;

function App() {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);

  useEffect(() => {
    // Check if admin is already authenticated
    const authStatus = localStorage.getItem('ahaarsewa_admin_auth');
    setIsAdminAuthenticated(authStatus === 'true');
  }, []);

  const handleAdminLogin = () => {
    setIsAdminAuthenticated(true);
  };

  const handleAdminLogout = () => {
    setIsAdminAuthenticated(false);
  };

  const MainSite = () => (
    <AppContainer>
      <Header />
      <Hero />
      <WhatIsBurritoSewa />
      <WhySponsor />
      <LifeEvents />
      <PastEvents />
      <ContactForm />
      <Footer />
    </AppContainer>
  );

  return (
    <SiteAuth>
      <Router>
        <Routes>
          <Route path="/" element={<MainSite />} />
          <Route path="/event-planning" element={<EventPlanning />} />
          <Route 
            path="/admin" 
            element={
              isAdminAuthenticated ? (
                <AdminDashboard onLogout={handleAdminLogout} />
              ) : (
                <AdminLogin onLogin={handleAdminLogin} />
              )
            } 
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </SiteAuth>
  );
}

export default App; 